import { useTranslate } from 'react-admin';
import { Chip } from '@mui/material';

import type { OfficialVaultRequest } from 'src/pages/admin/services/officialVaultService';

import { OFFICIAL_VAULTS_NS as NS } from './constants';
import { ApplicationView, statusChip } from './helpers';

export const StatusChip = ({
  request,
}: {
  request: Pick<ApplicationView, 'status' | 'kind' | 'vaultState' | 'vaultRaised'>;
}) => {
  const translate = useTranslate();
  const { labelKey, color } = statusChip(request);
  return (
    <Chip
      size="small"
      variant="outlined"
      color={color}
      label={labelKey ? translate(labelKey) : request.status}
    />
  );
};

/** Official / Community. A record without `kind` was written before C-08 v2 and is official. */
export const KindChip = ({ kind }: { kind?: OfficialVaultRequest['kind'] }) => {
  const translate = useTranslate();
  const community = kind === 'COMMUNITY';
  return (
    <Chip
      size="small"
      variant="soft"
      color={community ? 'secondary' : 'primary'}
      label={translate(`${NS}.kind.${community ? 'COMMUNITY' : 'OFFICIAL'}`)}
    />
  );
};
